import request from '@/utils/request'

/**
 * 获取帮助指南树形结构
 */
export function getHelpTree() {
    return request({
        url: '/shop/helpguide/api/tree',
        method: 'get'
    })
}

/**
 * 获取帮助文章详情
 * @param {number|string} id - 文章ID
 */
export function getHelpDetail(id) {
    return request({
        url: `/shop/helpguide/api/detail/${id}`,
        method: 'get'
    })
}
